module.exports = __webpack_public_path__ + "static/media/twitter-icon.d9c9cab9.svg";